<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Components
	import Icon from '@/Components/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let parentMarkets;
	export let sport;
	export let selectedParentMarket;
</script>

<table class="w-full whitespace-nowrap mt-3">
	<thead>
		<tr class="text-xs text-left text-gray-500 uppercase">
			<th class="px-6 pt-3 pb-2 font-medium">Parent Market</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Type</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Sport</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-center">Manual</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-right" />
		</tr>
	</thead>
	<tbody class="bg-white">
		{#each parentMarkets as parentMarket (parentMarket.id)}
			<tr
				on:click={() => {
					selectedParentMarket = parentMarket;
					dispatch('selected');
				}}
				class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100"
			>
				<td class="p-4 px-6 border-t">
					<div class="flex items-center">
						<div class="mr-2 font-semibold">{parentMarket.name}</div>
					</div>
				</td>
				<td class="w-px px-6 border-t text-left">
					{parentMarket.market_type.name}
					{#if parentMarket.market_type.label}
						[{parentMarket.market_type.label ?? ''}]
					{/if}
				</td>
				<td class="w-px px-6 border-t">
					<div class="px-2 py-1 bg-green-500 rounded-md text-light">
						{sport.name}
					</div>
				</td>
				<td class="w-px px-6 border-t text-left">
					{#if parentMarket.is_manual}
						<div class="px-2 py-1 bg-orange-500 rounded-md text-light">MANUAL</div>
					{/if}
				</td>
				<td class="w-px px-6 border-t">
					<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
				</td>
			</tr>
		{:else}
			<tr>
				<td class="px-6 py-4 text-center border-t" colspan="6">
					No parent markets found for {sport.name}.
				</td>
			</tr>
		{/each}
	</tbody>
</table>
